import AboutYouHeader from "@appally/assets/section/about-you-header.png";
import AboutYourJobHeader from "@appally/assets/section/about-your-job-header.png";
import WorkplaceChallengesHeader from "@appally/assets/section/workplace-challenges-header.png";
import { Section } from "@appally/collections/Assessment";
import { stringToSection } from "@appally/lib/utils/stringToSection";

type Content = {
  title: string;
  description: string;
  why?: string;
  thingsYouMightNeed?: string[];
  time: string;
  bgColor: string;
  textColor: string;
  image: string;
};

const sectionContent: Record<Section, Content> = {
  [Section.about_you]: {
    title: "About You",
    description:
      "Your responses show where work may be feeling more challenging. Next, we’ll ask a few more questions about you and your circumstances to build a supportive and meaningful Work Ally.",
    why: "This helps us learn about why you might be here and tailor your support options to your profile.",
    time: "2-5 minutes",
    bgColor: "yellow.500",
    textColor: "black.800",
    image: AboutYouHeader,
  },
  [Section.about_your_job]: {
    title: "About your work",
    description:
      "Let’s get started. Tell us about your role, responsibilities, and working patterns to build your personalised Work Ally.",
    why: "This helps us understand your role, routine, and the context you work in to further tailor your support recommendations.",
    time: "2-5 minutes",
    bgColor: "purple.500",
    textColor: "black.800",
    image: AboutYourJobHeader,
  },
  [Section.workplace_challenge]: {
    title: `Workplace Experience Assessment`,
    description:
      "Now, let’s look at your work experience and wellbeing. Share what’s working and what’s not, to build your personalised Work Ally.",
    why: "This helps us understand your areas of challenge and tailor our recommendations to your support needs.",
    time: "10-12 minutes",
    bgColor: "teal.500",
    textColor: "black.800",
    image: WorkplaceChallengesHeader,
  },
};

export const getSectionContent = (type: Section) => {
  return sectionContent[type];
};

export const getSectionContentFromString = (type: string) => {
  const section = stringToSection(type);
  if (!section) return;
  return getSectionContent(section);
};

export const useSectionContent = (type?: Section) => {
  if (!type) return;
  return getSectionContent(type);
};
